module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.filter,
      "items": _vm.filteredItems
    },
    scopedSlots: _vm._u([{
      key: "item.handle",
      fn: function(ref) {
        var item = ref.item;

        return [(item.handleEdit === false) ? _c('div', {
          staticClass: "item-edit"
        }, [_c('td', {
          staticClass: "text-left"
        }, [(item.handle) ? _c('social-handle', {
          attrs: {
            "isInstagram": item.value === 'instagram',
            "isTikTok": item.value === 'tiktok',
            "isYoutube": item.value === 'youtube',
            "isXiaohongshu": item.value === 'xiaohongshu',
            "isFacebook": item.value === 'facebook',
            "isLinkedIn": item.value === 'linkedin',
            "isTwitter": item.value === 'twitter',
            "instagramHandle": item.handle,
            "tiktokHandle": item.handle,
            "youtubeHandle": item.handle,
            "xiaohongshuHandle": item.handle,
            "facebookHandle": item.handle,
            "linkedinHandle": item.handle,
            "twitterHandle": item.handle,
            "divClassName": "float-left"
          }
        }) : _vm._e(), _vm._v(" "), _c('v-icon', {
          staticClass: "cursor-pointer pl-2",
          attrs: {
            "color": "warning",
            "x-small": "",
            "disabled": item.connected
          },
          on: {
            "click": function($event) {
              return _vm.openEditItem(item, 'handle', _vm.dataSourceName)
            }
          }
        }, [_vm._v("edit")])], 1)]) : _c('div', {
          staticClass: "item-edit"
        }, [_c('td', [_c('v-text-field', _vm._g({
          staticClass: "input-field mt-3",
          attrs: {
            "dense": "",
            "outlined": ""
          },
          model: {
            value: (item.handle),
            callback: function($$v) {
              _vm.$set(item, "handle", $$v)
            },
            expression: "item.handle"
          }
        }, _vm.on))], 1)])]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', [(item.connected) ? _c('v-btn', {
          attrs: {
            "disabled": "",
            "color": "success",
            "small": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("mdi-account-check")]), _vm._v(" "), _c('span', [_vm._v("Connected")])], 1) : _vm._e(), _vm._v(" "), (item.handle && !item.connected && !item.requested) ? _c('v-btn', {
          attrs: {
            "color": "success",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.connectAction(item, 'connect')
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("mdi-account-check")]), _vm._v(" "), _c('span', [_vm._v("Connect")])], 1) : _vm._e(), _vm._v(" "), (item.connected) ? _c('v-btn', {
          attrs: {
            "color": "error",
            "small": "",
            "disabled": _vm.filteredItems.filter(function (f) { return f.connected; }).length === 1
          },
          on: {
            "click": function($event) {
              return _vm.connectAction(item, 'disconnect')
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("mdi-account-remove")]), _vm._v(" Disconnect\n            ")], 1) : _vm._e(), _vm._v(" "), (item.handle && item.requested) ? _c('v-btn', {
          attrs: {
            "color": "success",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.connectAction(item, 'connect')
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("mdi-account-check")]), _vm._v(" "), _c('span', [_vm._v("Approve")])], 1) : _vm._e(), _vm._v(" "), (item.handle && item.requested) ? _c('v-btn', {
          attrs: {
            "color": "red",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.rejectPlatform(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("mdi-close")]), _vm._v(" "), _c('span', [_vm._v("Reject")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true)
  })], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-977b889a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/InfPlatforms/DataTable.vue
// module id = 2243
// module chunks = 0